import { render, staticRenderFns } from "./ActionShareDone.vue?vue&type=template&id=12e27286"
import script from "./ActionShareDone.vue?vue&type=script&lang=js"
export * from "./ActionShareDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports